import { Navigate, Outlet } from 'react-router';
import { TOOLKIT_PATH } from '../config';
import { useAppSelector } from '../store/hooks';

// A layout route, nested inside ProtectedLayout so a session is guaranteed to
// exist by the time this runs — it only ever narrows further. **UX only**: the
// content service enforces the same grant against the access token, so this
// exists to avoid a live link that 403s, not to be the security boundary
// itself.
export const RequireSdlcAccess = () => {
  const sdlcAccess = useAppSelector((state) => state.auth.user?.sdlcAccess ?? false);

  if (!sdlcAccess) {
    return <Navigate to={TOOLKIT_PATH} replace />;
  }

  return <Outlet />;
};
